import type { ReactNode } from "react";

import { TableBody, TableCell, TableRow } from "@/components/ui/table";
import { TableLoad } from "@/components/ui/table-load";
import { EmptyTable } from "@/components/Datatable/components/EmptyTable";

import { TABLE_REFRESHING_CLASS } from "../constants";

interface ItemsTableBodyProps {
  isFetching: boolean;
  isEmpty: boolean;
  columnCount: number;
  emptyText: string;
  children: ReactNode;
}

function ItemsTableBodyContent({
  isFetching,
  isEmpty,
  columnCount,
  emptyText,
  children,
}: ItemsTableBodyProps): JSX.Element {
  if (isEmpty && isFetching) return <TableLoad colSpan={columnCount} />;
  if (isEmpty) {
    return (
      <TableRow>
        <TableCell colSpan={columnCount} className="text-center h-24">
          <EmptyTable text={emptyText} />
        </TableCell>
      </TableRow>
    );
  }
  return <>{children}</>;
}

export default function ItemsTableBody(props: ItemsTableBodyProps): JSX.Element {
  return (
    <TableBody
      aria-busy={props.isFetching}
      className={props.isFetching ? TABLE_REFRESHING_CLASS : undefined}
    >
      <ItemsTableBodyContent {...props} />
    </TableBody>
  );
}
